module.exports = __webpack_public_path__ + "static/media/20210212_214430_589_IMG_2177.f9e39820.jpg";